/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PortalRouteImport } from './routes/portal'
import { Route as RedefinirRouteImport } from './routes/redefinir'
import { Route as SetupRouteImport } from './routes/setup'
import { Route as AppIndexRouteImport } from './routes/_app.index'
import { Route as AppAjudaRouteImport } from './routes/_app.ajuda'
import { Route as AppAuditoriaRouteImport } from './routes/_app.auditoria'
import { Route as AppCofreRouteImport } from './routes/_app.cofre'
import { Route as AppConfiguracoesRouteImport } from './routes/_app.configuracoes'
import { Route as AppConsultasRouteImport } from './routes/_app.consultas'
import { Route as AppDocumentosRouteImport } from './routes/_app.documentos'
import { Route as AppEmailsRouteImport } from './routes/_app.emails'
import { Route as AppEquipeRouteImport } from './routes/_app.equipe'
import { Route as AppFeriadosRouteImport } from './routes/_app.feriados'
import { Route as AppFluxosRouteImport } from './routes/_app.fluxos'
import { Route as AppGestaoRouteImport } from './routes/_app.gestao'
import { Route as AppGuiasRouteImport } from './routes/_app.guias'
import { Route as AppModelosTarefaRouteImport } from './routes/_app.modelos-tarefa'
import { Route as AppMuralRouteImport } from './routes/_app.mural'
import { Route as AppNotificacoesRouteImport } from './routes/_app.notificacoes'
import { Route as AppPedidosRouteImport } from './routes/_app.pedidos'
import { Route as AppPessoalRouteImport } from './routes/_app.pessoal'
import { Route as AppPlataformaRouteImport } from './routes/_app.plataforma'
import { Route as AppReformaRouteImport } from './routes/_app.reforma'
import { Route as AppRelatoriosRouteImport } from './routes/_app.relatorios'
import { Route as AppServicosRouteImport } from './routes/_app.servicos'
import { Route as AppSicalcRouteImport } from './routes/_app.sicalc'
import { Route as AppSituacaoFiscalRouteImport } from './routes/_app.situacao-fiscal'
import { Route as AppTarefasRouteImport } from './routes/_app.tarefas'
import { Route as AppVencimentosRouteImport } from './routes/_app.vencimentos'
import { Route as AssinarTokenRouteImport } from './routes/assinar.$token'
import { Route as PortalIndexRouteImport } from './routes/portal.index'
import { Route as PortalDocumentosRouteImport } from './routes/portal.documentos'
import { Route as PortalDriveRouteImport } from './routes/portal.drive'
import { Route as PortalEmpresaRouteImport } from './routes/portal.empresa'
import { Route as PortalEntrarRouteImport } from './routes/portal.entrar'
import { Route as PortalGuiasRouteImport } from './routes/portal.guias'
import { Route as PortalMensagensRouteImport } from './routes/portal.mensagens'
import { Route as PortalPedidosRouteImport } from './routes/portal.pedidos'
import { Route as PortalPedirRouteImport } from './routes/portal.pedir'
import { Route as PortalSenhaRouteImport } from './routes/portal.senha'
import { Route as RTokenRouteImport } from './routes/r.$token'
import { Route as AppClientesIndexRouteImport } from './routes/_app.clientes.index'
import { Route as AppClientesIdRouteImport } from './routes/_app.clientes.$id'
import { Route as AppClientesNovoRouteImport } from './routes/_app.clientes.novo'
import { Route as AppObrigacoesIndexRouteImport } from './routes/_app.obrigacoes.index'
import { Route as AppObrigacoesIdRouteImport } from './routes/_app.obrigacoes.$id'
import { Route as AppObrigacoesSimularRouteImport } from './routes/_app.obrigacoes.simular'
import { Route as AppProcessosIndexRouteImport } from './routes/_app.processos.index'
import { Route as AppProcessosIdRouteImport } from './routes/_app.processos.$id'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalRoute = PortalRouteImport.update({
  id: '/portal',
  path: '/portal',
  getParentRoute: () => rootRouteImport,
} as any)
const RedefinirRoute = RedefinirRouteImport.update({
  id: '/redefinir',
  path: '/redefinir',
  getParentRoute: () => rootRouteImport,
} as any)
const SetupRoute = SetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAjudaRoute = AppAjudaRouteImport.update({
  id: '/ajuda',
  path: '/ajuda',
  getParentRoute: () => AppRoute,
} as any)
const AppAuditoriaRoute = AppAuditoriaRouteImport.update({
  id: '/auditoria',
  path: '/auditoria',
  getParentRoute: () => AppRoute,
} as any)
const AppCofreRoute = AppCofreRouteImport.update({
  id: '/cofre',
  path: '/cofre',
  getParentRoute: () => AppRoute,
} as any)
const AppConfiguracoesRoute = AppConfiguracoesRouteImport.update({
  id: '/configuracoes',
  path: '/configuracoes',
  getParentRoute: () => AppRoute,
} as any)
const AppConsultasRoute = AppConsultasRouteImport.update({
  id: '/consultas',
  path: '/consultas',
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentosRoute = AppDocumentosRouteImport.update({
  id: '/documentos',
  path: '/documentos',
  getParentRoute: () => AppRoute,
} as any)
const AppEmailsRoute = AppEmailsRouteImport.update({
  id: '/emails',
  path: '/emails',
  getParentRoute: () => AppRoute,
} as any)
const AppEquipeRoute = AppEquipeRouteImport.update({
  id: '/equipe',
  path: '/equipe',
  getParentRoute: () => AppRoute,
} as any)
const AppFeriadosRoute = AppFeriadosRouteImport.update({
  id: '/feriados',
  path: '/feriados',
  getParentRoute: () => AppRoute,
} as any)
const AppFluxosRoute = AppFluxosRouteImport.update({
  id: '/fluxos',
  path: '/fluxos',
  getParentRoute: () => AppRoute,
} as any)
const AppGestaoRoute = AppGestaoRouteImport.update({
  id: '/gestao',
  path: '/gestao',
  getParentRoute: () => AppRoute,
} as any)
const AppGuiasRoute = AppGuiasRouteImport.update({
  id: '/guias',
  path: '/guias',
  getParentRoute: () => AppRoute,
} as any)
const AppModelosTarefaRoute = AppModelosTarefaRouteImport.update({
  id: '/modelos-tarefa',
  path: '/modelos-tarefa',
  getParentRoute: () => AppRoute,
} as any)
const AppMuralRoute = AppMuralRouteImport.update({
  id: '/mural',
  path: '/mural',
  getParentRoute: () => AppRoute,
} as any)
const AppNotificacoesRoute = AppNotificacoesRouteImport.update({
  id: '/notificacoes',
  path: '/notificacoes',
  getParentRoute: () => AppRoute,
} as any)
const AppPedidosRoute = AppPedidosRouteImport.update({
  id: '/pedidos',
  path: '/pedidos',
  getParentRoute: () => AppRoute,
} as any)
const AppPessoalRoute = AppPessoalRouteImport.update({
  id: '/pessoal',
  path: '/pessoal',
  getParentRoute: () => AppRoute,
} as any)
const AppPlataformaRoute = AppPlataformaRouteImport.update({
  id: '/plataforma',
  path: '/plataforma',
  getParentRoute: () => AppRoute,
} as any)
const AppReformaRoute = AppReformaRouteImport.update({
  id: '/reforma',
  path: '/reforma',
  getParentRoute: () => AppRoute,
} as any)
const AppRelatoriosRoute = AppRelatoriosRouteImport.update({
  id: '/relatorios',
  path: '/relatorios',
  getParentRoute: () => AppRoute,
} as any)
const AppServicosRoute = AppServicosRouteImport.update({
  id: '/servicos',
  path: '/servicos',
  getParentRoute: () => AppRoute,
} as any)
const AppSicalcRoute = AppSicalcRouteImport.update({
  id: '/sicalc',
  path: '/sicalc',
  getParentRoute: () => AppRoute,
} as any)
const AppSituacaoFiscalRoute = AppSituacaoFiscalRouteImport.update({
  id: '/situacao-fiscal',
  path: '/situacao-fiscal',
  getParentRoute: () => AppRoute,
} as any)
const AppTarefasRoute = AppTarefasRouteImport.update({
  id: '/tarefas',
  path: '/tarefas',
  getParentRoute: () => AppRoute,
} as any)
const AppVencimentosRoute = AppVencimentosRouteImport.update({
  id: '/vencimentos',
  path: '/vencimentos',
  getParentRoute: () => AppRoute,
} as any)
const AssinarTokenRoute = AssinarTokenRouteImport.update({
  id: '/assinar/$token',
  path: '/assinar/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalIndexRoute = PortalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalDocumentosRoute = PortalDocumentosRouteImport.update({
  id: '/documentos',
  path: '/documentos',
  getParentRoute: () => PortalRoute,
} as any)
const PortalDriveRoute = PortalDriveRouteImport.update({
  id: '/drive',
  path: '/drive',
  getParentRoute: () => PortalRoute,
} as any)
const PortalEmpresaRoute = PortalEmpresaRouteImport.update({
  id: '/empresa',
  path: '/empresa',
  getParentRoute: () => PortalRoute,
} as any)
const PortalEntrarRoute = PortalEntrarRouteImport.update({
  id: '/entrar',
  path: '/entrar',
  getParentRoute: () => PortalRoute,
} as any)
const PortalGuiasRoute = PortalGuiasRouteImport.update({
  id: '/guias',
  path: '/guias',
  getParentRoute: () => PortalRoute,
} as any)
const PortalMensagensRoute = PortalMensagensRouteImport.update({
  id: '/mensagens',
  path: '/mensagens',
  getParentRoute: () => PortalRoute,
} as any)
const PortalPedidosRoute = PortalPedidosRouteImport.update({
  id: '/pedidos',
  path: '/pedidos',
  getParentRoute: () => PortalRoute,
} as any)
const PortalPedirRoute = PortalPedirRouteImport.update({
  id: '/pedir',
  path: '/pedir',
  getParentRoute: () => PortalRoute,
} as any)
const PortalSenhaRoute = PortalSenhaRouteImport.update({
  id: '/senha',
  path: '/senha',
  getParentRoute: () => PortalRoute,
} as any)
const RTokenRoute = RTokenRouteImport.update({
  id: '/r/$token',
  path: '/r/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppClientesIndexRoute = AppClientesIndexRouteImport.update({
  id: '/clientes/',
  path: '/clientes/',
  getParentRoute: () => AppRoute,
} as any)
const AppClientesIdRoute = AppClientesIdRouteImport.update({
  id: '/clientes/$id',
  path: '/clientes/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppClientesNovoRoute = AppClientesNovoRouteImport.update({
  id: '/clientes/novo',
  path: '/clientes/novo',
  getParentRoute: () => AppRoute,
} as any)
const AppObrigacoesIndexRoute = AppObrigacoesIndexRouteImport.update({
  id: '/obrigacoes/',
  path: '/obrigacoes/',
  getParentRoute: () => AppRoute,
} as any)
const AppObrigacoesIdRoute = AppObrigacoesIdRouteImport.update({
  id: '/obrigacoes/$id',
  path: '/obrigacoes/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppObrigacoesSimularRoute = AppObrigacoesSimularRouteImport.update({
  id: '/obrigacoes/simular',
  path: '/obrigacoes/simular',
  getParentRoute: () => AppRoute,
} as any)
const AppProcessosIndexRoute = AppProcessosIndexRouteImport.update({
  id: '/processos/',
  path: '/processos/',
  getParentRoute: () => AppRoute,
} as any)
const AppProcessosIdRoute = AppProcessosIdRouteImport.update({
  id: '/processos/$id',
  path: '/processos/$id',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/portal': typeof PortalRouteWithChildren
  '/redefinir': typeof RedefinirRoute
  '/setup': typeof SetupRoute
  '/ajuda': typeof AppAjudaRoute
  '/auditoria': typeof AppAuditoriaRoute
  '/cofre': typeof AppCofreRoute
  '/configuracoes': typeof AppConfiguracoesRoute
  '/consultas': typeof AppConsultasRoute
  '/documentos': typeof AppDocumentosRoute
  '/emails': typeof AppEmailsRoute
  '/equipe': typeof AppEquipeRoute
  '/feriados': typeof AppFeriadosRoute
  '/fluxos': typeof AppFluxosRoute
  '/gestao': typeof AppGestaoRoute
  '/guias': typeof AppGuiasRoute
  '/modelos-tarefa': typeof AppModelosTarefaRoute
  '/mural': typeof AppMuralRoute
  '/notificacoes': typeof AppNotificacoesRoute
  '/pedidos': typeof AppPedidosRoute
  '/pessoal': typeof AppPessoalRoute
  '/plataforma': typeof AppPlataformaRoute
  '/reforma': typeof AppReformaRoute
  '/relatorios': typeof AppRelatoriosRoute
  '/servicos': typeof AppServicosRoute
  '/sicalc': typeof AppSicalcRoute
  '/situacao-fiscal': typeof AppSituacaoFiscalRoute
  '/tarefas': typeof AppTarefasRoute
  '/vencimentos': typeof AppVencimentosRoute
  '/assinar/$token': typeof AssinarTokenRoute
  '/portal/documentos': typeof PortalDocumentosRoute
  '/portal/drive': typeof PortalDriveRoute
  '/portal/empresa': typeof PortalEmpresaRoute
  '/portal/entrar': typeof PortalEntrarRoute
  '/portal/guias': typeof PortalGuiasRoute
  '/portal/mensagens': typeof PortalMensagensRoute
  '/portal/pedidos': typeof PortalPedidosRoute
  '/portal/pedir': typeof PortalPedirRoute
  '/portal/senha': typeof PortalSenhaRoute
  '/r/$token': typeof RTokenRoute
  '/portal/': typeof PortalIndexRoute
  '/clientes/$id': typeof AppClientesIdRoute
  '/clientes/novo': typeof AppClientesNovoRoute
  '/obrigacoes/$id': typeof AppObrigacoesIdRoute
  '/obrigacoes/simular': typeof AppObrigacoesSimularRoute
  '/processos/$id': typeof AppProcessosIdRoute
  '/clientes/': typeof AppClientesIndexRoute
  '/obrigacoes/': typeof AppObrigacoesIndexRoute
  '/processos/': typeof AppProcessosIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/redefinir': typeof RedefinirRoute
  '/setup': typeof SetupRoute
  '/ajuda': typeof AppAjudaRoute
  '/auditoria': typeof AppAuditoriaRoute
  '/cofre': typeof AppCofreRoute
  '/configuracoes': typeof AppConfiguracoesRoute
  '/consultas': typeof AppConsultasRoute
  '/documentos': typeof AppDocumentosRoute
  '/emails': typeof AppEmailsRoute
  '/equipe': typeof AppEquipeRoute
  '/feriados': typeof AppFeriadosRoute
  '/fluxos': typeof AppFluxosRoute
  '/gestao': typeof AppGestaoRoute
  '/guias': typeof AppGuiasRoute
  '/modelos-tarefa': typeof AppModelosTarefaRoute
  '/mural': typeof AppMuralRoute
  '/notificacoes': typeof AppNotificacoesRoute
  '/pedidos': typeof AppPedidosRoute
  '/pessoal': typeof AppPessoalRoute
  '/plataforma': typeof AppPlataformaRoute
  '/reforma': typeof AppReformaRoute
  '/relatorios': typeof AppRelatoriosRoute
  '/servicos': typeof AppServicosRoute
  '/sicalc': typeof AppSicalcRoute
  '/situacao-fiscal': typeof AppSituacaoFiscalRoute
  '/tarefas': typeof AppTarefasRoute
  '/vencimentos': typeof AppVencimentosRoute
  '/assinar/$token': typeof AssinarTokenRoute
  '/portal/documentos': typeof PortalDocumentosRoute
  '/portal/drive': typeof PortalDriveRoute
  '/portal/empresa': typeof PortalEmpresaRoute
  '/portal/entrar': typeof PortalEntrarRoute
  '/portal/guias': typeof PortalGuiasRoute
  '/portal/mensagens': typeof PortalMensagensRoute
  '/portal/pedidos': typeof PortalPedidosRoute
  '/portal/pedir': typeof PortalPedirRoute
  '/portal/senha': typeof PortalSenhaRoute
  '/r/$token': typeof RTokenRoute
  '/': typeof AppIndexRoute
  '/portal': typeof PortalIndexRoute
  '/clientes/$id': typeof AppClientesIdRoute
  '/clientes/novo': typeof AppClientesNovoRoute
  '/obrigacoes/$id': typeof AppObrigacoesIdRoute
  '/obrigacoes/simular': typeof AppObrigacoesSimularRoute
  '/processos/$id': typeof AppProcessosIdRoute
  '/clientes': typeof AppClientesIndexRoute
  '/obrigacoes': typeof AppObrigacoesIndexRoute
  '/processos': typeof AppProcessosIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/portal': typeof PortalRouteWithChildren
  '/redefinir': typeof RedefinirRoute
  '/setup': typeof SetupRoute
  '/_app/ajuda': typeof AppAjudaRoute
  '/_app/auditoria': typeof AppAuditoriaRoute
  '/_app/cofre': typeof AppCofreRoute
  '/_app/configuracoes': typeof AppConfiguracoesRoute
  '/_app/consultas': typeof AppConsultasRoute
  '/_app/documentos': typeof AppDocumentosRoute
  '/_app/emails': typeof AppEmailsRoute
  '/_app/equipe': typeof AppEquipeRoute
  '/_app/feriados': typeof AppFeriadosRoute
  '/_app/fluxos': typeof AppFluxosRoute
  '/_app/gestao': typeof AppGestaoRoute
  '/_app/guias': typeof AppGuiasRoute
  '/_app/modelos-tarefa': typeof AppModelosTarefaRoute
  '/_app/mural': typeof AppMuralRoute
  '/_app/notificacoes': typeof AppNotificacoesRoute
  '/_app/pedidos': typeof AppPedidosRoute
  '/_app/pessoal': typeof AppPessoalRoute
  '/_app/plataforma': typeof AppPlataformaRoute
  '/_app/reforma': typeof AppReformaRoute
  '/_app/relatorios': typeof AppRelatoriosRoute
  '/_app/servicos': typeof AppServicosRoute
  '/_app/sicalc': typeof AppSicalcRoute
  '/_app/situacao-fiscal': typeof AppSituacaoFiscalRoute
  '/_app/tarefas': typeof AppTarefasRoute
  '/_app/vencimentos': typeof AppVencimentosRoute
  '/assinar/$token': typeof AssinarTokenRoute
  '/portal/documentos': typeof PortalDocumentosRoute
  '/portal/drive': typeof PortalDriveRoute
  '/portal/empresa': typeof PortalEmpresaRoute
  '/portal/entrar': typeof PortalEntrarRoute
  '/portal/guias': typeof PortalGuiasRoute
  '/portal/mensagens': typeof PortalMensagensRoute
  '/portal/pedidos': typeof PortalPedidosRoute
  '/portal/pedir': typeof PortalPedirRoute
  '/portal/senha': typeof PortalSenhaRoute
  '/r/$token': typeof RTokenRoute
  '/_app/': typeof AppIndexRoute
  '/portal/': typeof PortalIndexRoute
  '/_app/clientes/$id': typeof AppClientesIdRoute
  '/_app/clientes/novo': typeof AppClientesNovoRoute
  '/_app/obrigacoes/$id': typeof AppObrigacoesIdRoute
  '/_app/obrigacoes/simular': typeof AppObrigacoesSimularRoute
  '/_app/processos/$id': typeof AppProcessosIdRoute
  '/_app/clientes/': typeof AppClientesIndexRoute
  '/_app/obrigacoes/': typeof AppObrigacoesIndexRoute
  '/_app/processos/': typeof AppProcessosIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/portal'
    | '/redefinir'
    | '/setup'
    | '/ajuda'
    | '/auditoria'
    | '/cofre'
    | '/configuracoes'
    | '/consultas'
    | '/documentos'
    | '/emails'
    | '/equipe'
    | '/feriados'
    | '/fluxos'
    | '/gestao'
    | '/guias'
    | '/modelos-tarefa'
    | '/mural'
    | '/notificacoes'
    | '/pedidos'
    | '/pessoal'
    | '/plataforma'
    | '/reforma'
    | '/relatorios'
    | '/servicos'
    | '/sicalc'
    | '/situacao-fiscal'
    | '/tarefas'
    | '/vencimentos'
    | '/assinar/$token'
    | '/portal/documentos'
    | '/portal/drive'
    | '/portal/empresa'
    | '/portal/entrar'
    | '/portal/guias'
    | '/portal/mensagens'
    | '/portal/pedidos'
    | '/portal/pedir'
    | '/portal/senha'
    | '/r/$token'
    | '/portal/'
    | '/clientes/$id'
    | '/clientes/novo'
    | '/obrigacoes/$id'
    | '/obrigacoes/simular'
    | '/processos/$id'
    | '/clientes/'
    | '/obrigacoes/'
    | '/processos/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/redefinir'
    | '/setup'
    | '/ajuda'
    | '/auditoria'
    | '/cofre'
    | '/configuracoes'
    | '/consultas'
    | '/documentos'
    | '/emails'
    | '/equipe'
    | '/feriados'
    | '/fluxos'
    | '/gestao'
    | '/guias'
    | '/modelos-tarefa'
    | '/mural'
    | '/notificacoes'
    | '/pedidos'
    | '/pessoal'
    | '/plataforma'
    | '/reforma'
    | '/relatorios'
    | '/servicos'
    | '/sicalc'
    | '/situacao-fiscal'
    | '/tarefas'
    | '/vencimentos'
    | '/assinar/$token'
    | '/portal/documentos'
    | '/portal/drive'
    | '/portal/empresa'
    | '/portal/entrar'
    | '/portal/guias'
    | '/portal/mensagens'
    | '/portal/pedidos'
    | '/portal/pedir'
    | '/portal/senha'
    | '/r/$token'
    | '/'
    | '/portal'
    | '/clientes/$id'
    | '/clientes/novo'
    | '/obrigacoes/$id'
    | '/obrigacoes/simular'
    | '/processos/$id'
    | '/clientes'
    | '/obrigacoes'
    | '/processos'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/portal'
    | '/redefinir'
    | '/setup'
    | '/_app/ajuda'
    | '/_app/auditoria'
    | '/_app/cofre'
    | '/_app/configuracoes'
    | '/_app/consultas'
    | '/_app/documentos'
    | '/_app/emails'
    | '/_app/equipe'
    | '/_app/feriados'
    | '/_app/fluxos'
    | '/_app/gestao'
    | '/_app/guias'
    | '/_app/modelos-tarefa'
    | '/_app/mural'
    | '/_app/notificacoes'
    | '/_app/pedidos'
    | '/_app/pessoal'
    | '/_app/plataforma'
    | '/_app/reforma'
    | '/_app/relatorios'
    | '/_app/servicos'
    | '/_app/sicalc'
    | '/_app/situacao-fiscal'
    | '/_app/tarefas'
    | '/_app/vencimentos'
    | '/assinar/$token'
    | '/portal/documentos'
    | '/portal/drive'
    | '/portal/empresa'
    | '/portal/entrar'
    | '/portal/guias'
    | '/portal/mensagens'
    | '/portal/pedidos'
    | '/portal/pedir'
    | '/portal/senha'
    | '/r/$token'
    | '/_app/'
    | '/portal/'
    | '/_app/clientes/$id'
    | '/_app/clientes/novo'
    | '/_app/obrigacoes/$id'
    | '/_app/obrigacoes/simular'
    | '/_app/processos/$id'
    | '/_app/clientes/'
    | '/_app/obrigacoes/'
    | '/_app/processos/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  PortalRoute: typeof PortalRouteWithChildren
  RedefinirRoute: typeof RedefinirRoute
  SetupRoute: typeof SetupRoute
  AssinarTokenRoute: typeof AssinarTokenRoute
  RTokenRoute: typeof RTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal': {
      id: '/portal'
      path: '/portal'
      fullPath: '/portal'
      preLoaderRoute: typeof PortalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/redefinir': {
      id: '/redefinir'
      path: '/redefinir'
      fullPath: '/redefinir'
      preLoaderRoute: typeof RedefinirRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setup': {
      id: '/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof SetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ajuda': {
      id: '/_app/ajuda'
      path: '/ajuda'
      fullPath: '/ajuda'
      preLoaderRoute: typeof AppAjudaRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/auditoria': {
      id: '/_app/auditoria'
      path: '/auditoria'
      fullPath: '/auditoria'
      preLoaderRoute: typeof AppAuditoriaRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cofre': {
      id: '/_app/cofre'
      path: '/cofre'
      fullPath: '/cofre'
      preLoaderRoute: typeof AppCofreRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/configuracoes': {
      id: '/_app/configuracoes'
      path: '/configuracoes'
      fullPath: '/configuracoes'
      preLoaderRoute: typeof AppConfiguracoesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/consultas': {
      id: '/_app/consultas'
      path: '/consultas'
      fullPath: '/consultas'
      preLoaderRoute: typeof AppConsultasRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/documentos': {
      id: '/_app/documentos'
      path: '/documentos'
      fullPath: '/documentos'
      preLoaderRoute: typeof AppDocumentosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/emails': {
      id: '/_app/emails'
      path: '/emails'
      fullPath: '/emails'
      preLoaderRoute: typeof AppEmailsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/equipe': {
      id: '/_app/equipe'
      path: '/equipe'
      fullPath: '/equipe'
      preLoaderRoute: typeof AppEquipeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/feriados': {
      id: '/_app/feriados'
      path: '/feriados'
      fullPath: '/feriados'
      preLoaderRoute: typeof AppFeriadosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/fluxos': {
      id: '/_app/fluxos'
      path: '/fluxos'
      fullPath: '/fluxos'
      preLoaderRoute: typeof AppFluxosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gestao': {
      id: '/_app/gestao'
      path: '/gestao'
      fullPath: '/gestao'
      preLoaderRoute: typeof AppGestaoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/guias': {
      id: '/_app/guias'
      path: '/guias'
      fullPath: '/guias'
      preLoaderRoute: typeof AppGuiasRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/modelos-tarefa': {
      id: '/_app/modelos-tarefa'
      path: '/modelos-tarefa'
      fullPath: '/modelos-tarefa'
      preLoaderRoute: typeof AppModelosTarefaRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/mural': {
      id: '/_app/mural'
      path: '/mural'
      fullPath: '/mural'
      preLoaderRoute: typeof AppMuralRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/notificacoes': {
      id: '/_app/notificacoes'
      path: '/notificacoes'
      fullPath: '/notificacoes'
      preLoaderRoute: typeof AppNotificacoesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pedidos': {
      id: '/_app/pedidos'
      path: '/pedidos'
      fullPath: '/pedidos'
      preLoaderRoute: typeof AppPedidosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pessoal': {
      id: '/_app/pessoal'
      path: '/pessoal'
      fullPath: '/pessoal'
      preLoaderRoute: typeof AppPessoalRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/plataforma': {
      id: '/_app/plataforma'
      path: '/plataforma'
      fullPath: '/plataforma'
      preLoaderRoute: typeof AppPlataformaRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reforma': {
      id: '/_app/reforma'
      path: '/reforma'
      fullPath: '/reforma'
      preLoaderRoute: typeof AppReformaRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/relatorios': {
      id: '/_app/relatorios'
      path: '/relatorios'
      fullPath: '/relatorios'
      preLoaderRoute: typeof AppRelatoriosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/servicos': {
      id: '/_app/servicos'
      path: '/servicos'
      fullPath: '/servicos'
      preLoaderRoute: typeof AppServicosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sicalc': {
      id: '/_app/sicalc'
      path: '/sicalc'
      fullPath: '/sicalc'
      preLoaderRoute: typeof AppSicalcRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/situacao-fiscal': {
      id: '/_app/situacao-fiscal'
      path: '/situacao-fiscal'
      fullPath: '/situacao-fiscal'
      preLoaderRoute: typeof AppSituacaoFiscalRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tarefas': {
      id: '/_app/tarefas'
      path: '/tarefas'
      fullPath: '/tarefas'
      preLoaderRoute: typeof AppTarefasRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/vencimentos': {
      id: '/_app/vencimentos'
      path: '/vencimentos'
      fullPath: '/vencimentos'
      preLoaderRoute: typeof AppVencimentosRouteImport
      parentRoute: typeof AppRoute
    }
    '/assinar/$token': {
      id: '/assinar/$token'
      path: '/assinar/$token'
      fullPath: '/assinar/$token'
      preLoaderRoute: typeof AssinarTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/': {
      id: '/portal/'
      path: '/'
      fullPath: '/portal/'
      preLoaderRoute: typeof PortalIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/documentos': {
      id: '/portal/documentos'
      path: '/documentos'
      fullPath: '/portal/documentos'
      preLoaderRoute: typeof PortalDocumentosRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/drive': {
      id: '/portal/drive'
      path: '/drive'
      fullPath: '/portal/drive'
      preLoaderRoute: typeof PortalDriveRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/empresa': {
      id: '/portal/empresa'
      path: '/empresa'
      fullPath: '/portal/empresa'
      preLoaderRoute: typeof PortalEmpresaRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/entrar': {
      id: '/portal/entrar'
      path: '/entrar'
      fullPath: '/portal/entrar'
      preLoaderRoute: typeof PortalEntrarRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/guias': {
      id: '/portal/guias'
      path: '/guias'
      fullPath: '/portal/guias'
      preLoaderRoute: typeof PortalGuiasRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/mensagens': {
      id: '/portal/mensagens'
      path: '/mensagens'
      fullPath: '/portal/mensagens'
      preLoaderRoute: typeof PortalMensagensRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/pedidos': {
      id: '/portal/pedidos'
      path: '/pedidos'
      fullPath: '/portal/pedidos'
      preLoaderRoute: typeof PortalPedidosRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/pedir': {
      id: '/portal/pedir'
      path: '/pedir'
      fullPath: '/portal/pedir'
      preLoaderRoute: typeof PortalPedirRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/senha': {
      id: '/portal/senha'
      path: '/senha'
      fullPath: '/portal/senha'
      preLoaderRoute: typeof PortalSenhaRouteImport
      parentRoute: typeof PortalRoute
    }
    '/r/$token': {
      id: '/r/$token'
      path: '/r/$token'
      fullPath: '/r/$token'
      preLoaderRoute: typeof RTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/clientes/': {
      id: '/_app/clientes/'
      path: '/clientes'
      fullPath: '/clientes/'
      preLoaderRoute: typeof AppClientesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clientes/$id': {
      id: '/_app/clientes/$id'
      path: '/clientes/$id'
      fullPath: '/clientes/$id'
      preLoaderRoute: typeof AppClientesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clientes/novo': {
      id: '/_app/clientes/novo'
      path: '/clientes/novo'
      fullPath: '/clientes/novo'
      preLoaderRoute: typeof AppClientesNovoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/obrigacoes/': {
      id: '/_app/obrigacoes/'
      path: '/obrigacoes'
      fullPath: '/obrigacoes/'
      preLoaderRoute: typeof AppObrigacoesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/obrigacoes/$id': {
      id: '/_app/obrigacoes/$id'
      path: '/obrigacoes/$id'
      fullPath: '/obrigacoes/$id'
      preLoaderRoute: typeof AppObrigacoesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/obrigacoes/simular': {
      id: '/_app/obrigacoes/simular'
      path: '/obrigacoes/simular'
      fullPath: '/obrigacoes/simular'
      preLoaderRoute: typeof AppObrigacoesSimularRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/processos/': {
      id: '/_app/processos/'
      path: '/processos'
      fullPath: '/processos/'
      preLoaderRoute: typeof AppProcessosIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/processos/$id': {
      id: '/_app/processos/$id'
      path: '/processos/$id'
      fullPath: '/processos/$id'
      preLoaderRoute: typeof AppProcessosIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAjudaRoute: typeof AppAjudaRoute
  AppAuditoriaRoute: typeof AppAuditoriaRoute
  AppCofreRoute: typeof AppCofreRoute
  AppConfiguracoesRoute: typeof AppConfiguracoesRoute
  AppConsultasRoute: typeof AppConsultasRoute
  AppDocumentosRoute: typeof AppDocumentosRoute
  AppEmailsRoute: typeof AppEmailsRoute
  AppEquipeRoute: typeof AppEquipeRoute
  AppFeriadosRoute: typeof AppFeriadosRoute
  AppFluxosRoute: typeof AppFluxosRoute
  AppGestaoRoute: typeof AppGestaoRoute
  AppGuiasRoute: typeof AppGuiasRoute
  AppModelosTarefaRoute: typeof AppModelosTarefaRoute
  AppMuralRoute: typeof AppMuralRoute
  AppNotificacoesRoute: typeof AppNotificacoesRoute
  AppPedidosRoute: typeof AppPedidosRoute
  AppPessoalRoute: typeof AppPessoalRoute
  AppPlataformaRoute: typeof AppPlataformaRoute
  AppReformaRoute: typeof AppReformaRoute
  AppRelatoriosRoute: typeof AppRelatoriosRoute
  AppServicosRoute: typeof AppServicosRoute
  AppSicalcRoute: typeof AppSicalcRoute
  AppSituacaoFiscalRoute: typeof AppSituacaoFiscalRoute
  AppTarefasRoute: typeof AppTarefasRoute
  AppVencimentosRoute: typeof AppVencimentosRoute
  AppIndexRoute: typeof AppIndexRoute
  AppClientesIdRoute: typeof AppClientesIdRoute
  AppClientesNovoRoute: typeof AppClientesNovoRoute
  AppObrigacoesIdRoute: typeof AppObrigacoesIdRoute
  AppObrigacoesSimularRoute: typeof AppObrigacoesSimularRoute
  AppProcessosIdRoute: typeof AppProcessosIdRoute
  AppClientesIndexRoute: typeof AppClientesIndexRoute
  AppObrigacoesIndexRoute: typeof AppObrigacoesIndexRoute
  AppProcessosIndexRoute: typeof AppProcessosIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAjudaRoute: AppAjudaRoute,
  AppAuditoriaRoute: AppAuditoriaRoute,
  AppCofreRoute: AppCofreRoute,
  AppConfiguracoesRoute: AppConfiguracoesRoute,
  AppConsultasRoute: AppConsultasRoute,
  AppDocumentosRoute: AppDocumentosRoute,
  AppEmailsRoute: AppEmailsRoute,
  AppEquipeRoute: AppEquipeRoute,
  AppFeriadosRoute: AppFeriadosRoute,
  AppFluxosRoute: AppFluxosRoute,
  AppGestaoRoute: AppGestaoRoute,
  AppGuiasRoute: AppGuiasRoute,
  AppModelosTarefaRoute: AppModelosTarefaRoute,
  AppMuralRoute: AppMuralRoute,
  AppNotificacoesRoute: AppNotificacoesRoute,
  AppPedidosRoute: AppPedidosRoute,
  AppPessoalRoute: AppPessoalRoute,
  AppPlataformaRoute: AppPlataformaRoute,
  AppReformaRoute: AppReformaRoute,
  AppRelatoriosRoute: AppRelatoriosRoute,
  AppServicosRoute: AppServicosRoute,
  AppSicalcRoute: AppSicalcRoute,
  AppSituacaoFiscalRoute: AppSituacaoFiscalRoute,
  AppTarefasRoute: AppTarefasRoute,
  AppVencimentosRoute: AppVencimentosRoute,
  AppIndexRoute: AppIndexRoute,
  AppClientesIdRoute: AppClientesIdRoute,
  AppClientesNovoRoute: AppClientesNovoRoute,
  AppObrigacoesIdRoute: AppObrigacoesIdRoute,
  AppObrigacoesSimularRoute: AppObrigacoesSimularRoute,
  AppProcessosIdRoute: AppProcessosIdRoute,
  AppClientesIndexRoute: AppClientesIndexRoute,
  AppObrigacoesIndexRoute: AppObrigacoesIndexRoute,
  AppProcessosIndexRoute: AppProcessosIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface PortalRouteChildren {
  PortalDocumentosRoute: typeof PortalDocumentosRoute
  PortalDriveRoute: typeof PortalDriveRoute
  PortalEmpresaRoute: typeof PortalEmpresaRoute
  PortalEntrarRoute: typeof PortalEntrarRoute
  PortalGuiasRoute: typeof PortalGuiasRoute
  PortalMensagensRoute: typeof PortalMensagensRoute
  PortalPedidosRoute: typeof PortalPedidosRoute
  PortalPedirRoute: typeof PortalPedirRoute
  PortalSenhaRoute: typeof PortalSenhaRoute
  PortalIndexRoute: typeof PortalIndexRoute
}

const PortalRouteChildren: PortalRouteChildren = {
  PortalDocumentosRoute: PortalDocumentosRoute,
  PortalDriveRoute: PortalDriveRoute,
  PortalEmpresaRoute: PortalEmpresaRoute,
  PortalEntrarRoute: PortalEntrarRoute,
  PortalGuiasRoute: PortalGuiasRoute,
  PortalMensagensRoute: PortalMensagensRoute,
  PortalPedidosRoute: PortalPedidosRoute,
  PortalPedirRoute: PortalPedirRoute,
  PortalSenhaRoute: PortalSenhaRoute,
  PortalIndexRoute: PortalIndexRoute,
}

const PortalRouteWithChildren =
  PortalRoute._addFileChildren(PortalRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  PortalRoute: PortalRouteWithChildren,
  RedefinirRoute: RedefinirRoute,
  SetupRoute: SetupRoute,
  AssinarTokenRoute: AssinarTokenRoute,
  RTokenRoute: RTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
